module.exports = __webpack_public_path__ + "fa7980dc7d39c16c1303802719a537df.png";